import React from 'react';

import { ITargetingPreset, TargetingPresetKey } from '~/src/dash/apiV2/targeting/targetingPresets';
import { borderRadius, Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { ELogicalOperator } from '~/src/dash/utils/options';
import { TargetingPresetParamKey } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/config';
import { IncludeExcludeString } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/TargetingSummaryTable/IncludeExcludeString';

const labelWidth = 100;

export interface IAppBundleSitePagesSummaryProps {
  preset: ITargetingPreset;
  appBundleIDKey: TargetingPresetKey;
  appBundleIDAllowedKey: TargetingPresetKey;
  sitePagesKey: TargetingPresetKey;
  sitePagesAllowedKey: TargetingPresetKey;
  logicKey: TargetingPresetKey;
  paramKey: TargetingPresetParamKey;
}

export const AppBundleSitePagesSummary = ({
  preset,
  appBundleIDKey,
  appBundleIDAllowedKey,
  sitePagesKey,
  sitePagesAllowedKey,
  logicKey,
  paramKey,
}: IAppBundleSitePagesSummaryProps) => {
  const appBundleID = preset[appBundleIDKey];
  const sitePage = preset[sitePagesKey];
  const logic = preset[logicKey];
  return (
    <div>
      {appBundleID !== '' && sitePage !== '' && (
        <Cols>
          <Col>
            <Text
              small
              style={{
                textAlign: 'right',
                paddingRight: spacing.small,
                width: labelWidth + 'px',
              }}
            >
              Logic
            </Text>
          </Col>
          <Col>
            <Text
              extraSmall
              bold
              disableSelect
              style={{
                border: `1px solid ${publicaColors.veryDarkGray}`,
                borderRadius: borderRadius.base,
                padding: `1px ${spacing.extraSmall} 0`,
                textAlign: 'center',
                width: '36px',
                backgroundColor:
                  logic === ELogicalOperator.OR
                    ? publicaColors.veryLightYellow
                    : publicaColors.veryLightPurple,
              }}
            >
              {logic === ELogicalOperator.OR ? 'OR' : 'AND'}
            </Text>
          </Col>
        </Cols>
      )}
      {appBundleID !== '' && (
        <Cols>
          <Col>
            <Text
              small
              bold
              style={{
                width: labelWidth + 'px',
              }}
            >
              App Bundle ID
            </Text>
          </Col>
          <Col>
            <IncludeExcludeString
              preset={preset}
              valueKey={appBundleIDKey}
              allowKey={appBundleIDAllowedKey}
              isAllowTypeBool={true}
              paramKey={paramKey}
            />
          </Col>
        </Cols>
      )}
      {sitePage !== '' && (
        <Cols>
          <Col>
            <Text
              small
              bold
              style={{
                width: labelWidth + 'px',
              }}
            >
              Site Pages
            </Text>
          </Col>
          <Col>
            <IncludeExcludeString
              preset={preset}
              valueKey={sitePagesKey}
              allowKey={sitePagesAllowedKey}
              isAllowTypeBool={false}
              paramKey={paramKey}
            />
          </Col>
        </Cols>
      )}
    </div>
  );
};
